import { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const nav = [
  { to: "/", label: "首页" },
  { to: "/channel/xingdong", label: "明星动态" },
  { to: "/channel/baoliao", label: "小道消息" },
  { to: "/channel/shendu", label: "深度挖掘" },
  { to: "/channel/bianliao", label: "边角料" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const navigate = useNavigate();

  const goTrend = () => {
    const scroll = () => {
      const el = document.getElementById("trend");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    };
    if (pathname === "/") {
      scroll();
    } else {
      navigate("/");
      window.setTimeout(scroll, 120);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-1.5 flex items-center justify-between text-xs tracking-wide">
          <p className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-[9px]"></i>
            </span>
            今日宜吃瓜 · 让每个瓜都比旁人吃得更透更深
          </p>
          <p className="flex items-center gap-4 text-background-100/70">
            <span>深度观察 理性吃瓜</span>
            <span className="hidden lg:inline">编辑部 · 四个栏目持续更新</span>
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between gap-4 py-3">
          <Link to="/" className="flex items-center gap-2.5 group" aria-label="在线吃瓜 首页">
            {isHome ? (
              <h1 className="flex items-center gap-2.5 m-0">
                <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 font-bold text-xl font-heading shadow-soft">
                  瓜
                </span>
                <span className="leading-none">
                  <span className="block font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    在线吃瓜
                  </span>
                  <span className="block text-[10px] tracking-[0.2em] text-foreground-500 mt-1">
                    深挖 · 吃透
                  </span>
                </span>
              </h1>
            ) : (
              <span className="flex items-center gap-2.5">
                <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 font-bold text-xl font-heading shadow-soft">
                  瓜
                </span>
                <span className="leading-none">
                  <span className="block font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    在线吃瓜
                  </span>
                  <span className="block text-[10px] tracking-[0.2em] text-foreground-500 mt-1">
                    深挖 · 吃透
                  </span>
                </span>
              </span>
            )}
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap px-3.5 py-2 text-sm rounded-md transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-primary-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={goTrend}
              className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium px-3.5 py-2 rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors"
            >
              <i className="ri-bar-chart-2-line"></i>
              今日热榜
            </button>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="展开菜单"
              aria-expanded={open}
              className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-background-300 text-foreground-900"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-4-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-background-200 bg-background-50 px-4 md:px-6 py-4" aria-label="移动端导航">
          <div className="grid grid-cols-1 gap-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block px-3 py-2.5 rounded-md text-[15px] ${
                    isActive
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}